import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiCircularProgress(_theme: Theme): MuiThemeComponentOverride<"MuiCircularProgress"> {
  return {
    MuiCircularProgress: {
      styleOverrides: {
        svg: {
          "&:focus": {
            outline: "unset",
          },
        },
      },
    },
  };
}
